import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlinedGreenRightArrowIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.94445 12.9088L17.77 12.9088L14.2 16.4328C14.0247 16.605 13.9262 16.8385 13.9262 17.082C13.9262 17.3254 14.0247 17.5589 14.2 17.7311C14.3753 17.9033 14.6131 18 14.8611 18C15.1091 18 15.3469 17.9033 15.5222 17.7311L20.6978 12.6677C20.7934 12.5837 20.8698 12.4808 20.9219 12.3657C20.974 12.2506 21.0006 12.126 21 12C21.0006 11.8741 20.974 11.7494 20.9219 11.6343C20.8698 11.5192 20.7934 11.4163 20.6978 11.3323L15.5222 6.26889C15.3469 6.09672 15.1091 6 14.8611 6C14.6131 6 14.3753 6.09672 14.2 6.26889C14.0247 6.44105 13.9262 6.67456 13.9262 6.91804C13.9262 7.16152 14.0247 7.39504 14.2 7.56721L17.77 11.0912L4.94445 11.0912C4.69397 11.0912 4.45374 11.1889 4.27662 11.3628C4.09951 11.5367 4 11.7726 4 12.0185C4 12.2645 4.09951 12.5004 4.27662 12.6743C4.45374 12.8482 4.69397 12.9459 4.94445 12.9459L4.94445 12.9088Z",
		fill: "#147752"
	})]
});
const ForwardRef = forwardRef(SvgOutlinedGreenRightArrowIcon);
const Memo = memo(ForwardRef);
export default Memo;
